import React from 'react';

import { GenericP, GenericDiv, Heading, FlexDiv } from '../../../common/Styles';
import { HomepageBannerLeft } from '../Styles';
import * as S from '../../components/BannerCarousel/BannerCarouselStyle';
import GetStartedButton from '../../components/GetStartedButton/GetStartedButton';

const Panel = ({ isMobile, carouselData, navClick }) => {
	const { heading, subHeading, url } = carouselData;
	return (
		<S.HomepageBannerContainer reverse={isMobile}>
			<HomepageBannerLeft $width='65%'>
				<Heading
					className='appendTop16'
					font_size={`${isMobile ? '24' : '54'}`}
					marBt='16px'
					appendTop16>
					{heading}
				</Heading>
				<GenericP fsize={isMobile ? '14px' : '22px'} color='#4a4a4a'>
					{subHeading}
				</GenericP>
				<GenericDiv bottom_P='20' top_M='20'>
					<GetStartedButton navClick={navClick} />
				</GenericDiv>
			</HomepageBannerLeft>
			<FlexDiv
				className='img-wrap'
				position='relative'
				$width={`${isMobile ? '100%' : '300px'}`}
				height={`${isMobile ? '150px' : '300px'}`}>
				<img crossOrigin='anonymous' className='bannerimg' width={isMobile ? '43%' : '100%'} height='auto' src={url} alt='banner_image' style={{ 'right': '5px', 'top': isMobile ? 'auto' : '100px', 'bottom': isMobile ? '-8px' : 'auto', 'position': 'absolute', 'minHeight': isMobile ? 'auto' : '300px', 'maxHeight': isMobile ? '150px' : 'auto', 'objectFit': 'contain', 'objectPosition': '0 0' }} />
			</FlexDiv>
		</S.HomepageBannerContainer>
	);
};

export default Panel;
